import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FaLightbulb } from "react-icons/fa6";
import { FiBriefcase, FiMail } from "react-icons/fi";
import { LuLightbulb } from "react-icons/lu";

interface BadgeFlotanteProps {
  t: (e: string) => string | number;
  prefix: string;
}

export default function BadgeFlotante({ t, prefix }: BadgeFlotanteProps) {
  return (
    <Box
      sx={{
        position: "absolute",
        bottom: -20,
        left: -20,
        bgcolor: "rgba(255,255,255,0.9)",
        backdropFilter: "blur(10px)",
        p: 2,
        borderRadius: 4,
        boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
        display: "flex",
        alignItems: "center",
        gap: 2,
        border: "1px solid #fff",
        animation: "floatAnimation 4s ease-in-out infinite",
        "@keyframes floatAnimation": {
          "0%": { transform: "translateY(0px)" },
          "50%": { transform: "translateY(-10px)" },
          "100%": { transform: "translateY(0px)" },
        },
      }}
    >
      {prefix.toLowerCase() !== "nosotros" ? (
        <Box
          sx={{
            width: 50,
            height: 50,
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:
              "linear-gradient(135deg, rgba(104, 168, 222, 0.1) 0%, rgba(104, 168, 222, 0.1) 100%)",
            color: "#68a8de",
          }}
        >
         {(prefix.toLowerCase() === "postulate")? <FiBriefcase size={28} />: (prefix.toLowerCase() === "pages.servicios")? <LuLightbulb size={28} />:<FiMail size={28} />}         </Box>
      ) : (
        <Box
          sx={{
            width: 50,
            height: 50,
            bgcolor: "#0056b3",
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontWeight: "bold",
            fontSize: "1.5rem",
          }}
        >
          20
        </Box>
      )}
      <Box>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 800, color: "#0A1128" }}
        >
          {t(`${prefix}.hero.years`)}
        </Typography>
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
          {t(`${prefix}.hero.yearsSub`)}
        </Typography>
      </Box>
    </Box>
  );
}
